import { render } from "./PageProductGroupList.vue?vue&type=template&id=3e0714fe"
import script from "./PageProductGroupList.vue?vue&type=script&lang=js"
export * from "./PageProductGroupList.vue?vue&type=script&lang=js"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__